import { useSelector } from 'react-redux';
import { shopSelector } from '@/redux/slice/shop.slice';
import { AppPricingPlan, AppPricingType } from '@/constants/enum';

const UserPlans = () => {
  const infoShop = useSelector(shopSelector);

  const shopifyPlusNameAllVersions = ['shopify_plus', 'Shopify Plus'];
  const isStoreShopifyPlus = shopifyPlusNameAllVersions.includes(infoShop?.shopifyPlan || '');
  // const isStoreShopifyPlus = true;

  const appPlanCurrent = infoShop?.appPlan as AppPricingPlan;

  // Pricing in App
  const isUserLimited = infoShop?.pricingType === AppPricingType.Limited;

  const isUserFree = appPlanCurrent === AppPricingPlan.Free;
  const isUserFreeLimited = isUserLimited && isUserFree;

  const isUserPaid = appPlanCurrent === AppPricingPlan.Paid;
  const isUserBasicLimited = isUserLimited && isUserPaid;

  const isUserFreeOrBasicLimited = isUserFreeLimited || isUserBasicLimited;

  return {
    appPlanCurrent,

    isStoreShopifyPlus,

    isUserLimited,
    // isUserFree,
    // isUserBasic,

    isUserFreeLimited,
    isUserBasicLimited,

    isUserFreeOrBasicLimited,
  };
};

export default UserPlans;
